<template>
  <div class="xinTu-footer">
    <div class="footer">
      <div class="left">
        <div class="bt">
          Thông tin liên lạc</div>
        <div class="title">705878399</div>
        <div class="title">cs@xintupawnshop.com</div>
      </div>
      <div class="footerTime">
        <img src="../assets/footerTime.png" alt="">
        <div class="footerTimeBox">
          <p>MỞ CỬA HÀNG NGÀY</p>
          <p>10:00 AM - 8:00 PM</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">Địa chỉ</div>
      <div class="text">39/1, Ngõ 97, Đường Trần Văn Xá, Quận 3, P. Trảng Dài, Thành phố Biên Hòa, Tỉnh Đồng Nai, Việt Nam
      </div>
    </div>
    <div class="copyright">
      <img src="../assets/footer.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    send() {
      alert('ความสำเร็จ!')
    },
  },
};
</script>
<style lang="less" scoped>
.xinTu-footer {
  padding-top: 100px;

  .footer {
    display: flex;
    justify-content: space-between;
    padding: 0 72px;

    .footerTime {
      position: relative;

      img {
        width: 574px;
        height: 275px;
      }

      .footerTimeBox {
        position: absolute;
        bottom: 100px;
        left: 54px;

        p {
          font-size: 32px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #FFFFFF;
        }
      }
    }


    .left {
      margin-bottom: 10px;


      .bt {
        margin-bottom: 20px;
        font-size: 40px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #333333;
        line-height: 56px;
      }

      .title {
        margin-bottom: 16px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #DBA35C;
      }
    }
  }

  .content {
    padding: 0 72px;

    .title {
      margin-bottom: 20px;
      font-size: 32px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #333333;
      line-height: 37px;
    }

    .text {
      margin-bottom: 100px;
      font-size: 24px;
      font-family: ArialMT;
      color: #999999
    }
  }

  .copyright {
    img {
      vertical-align: bottom;
      width: 100%;
      height: 16px;
    }
  }
}
</style>
